import CBLinkWidget from "./CBLinkWidget";
import DiscordLinkWidget from "./discord/DiscordLinkWidget";

const LinkAccounts = () => {
  return (
    <div className="bg-base-200 h-full flex flex-col gap-2 items-center">
      <div className="p-2">Link your Accounts</div>
      <div className="flex flex-row flex-wrap  gap-2 p-2 ">
        <DiscordLinkWidget />
        <CBLinkWidget />
      </div>
    </div>
  );
};

export default LinkAccounts;
